<div class="agenda-appointment-row" fxLayout="row">
    <div fxFlex="100px">{{appointment.getProperty('Day')}}/{{appointment.getProperty('Month')}}/{{appointment.getProperty('Year')}}</div>
    <div fxFlex="80px">{{appointment.getProperty('Hour')}}:{{appointment.getProperty('Minute')}}</div>
    <div fxFlex="100px">Status</div>
    <div fxFlex *ngIf="isShown('patient')">{{appointment.getProperty('PatientInfo')}}</div>
    <div fxFlex>{{appointment.getProperty('Description')}}</div>
    <div fxFlex="250px">{{appointment.getProperty('UserInfo')}}</div>
</div>
